/**
 * Combines Algolia SearchParameters.disjunctiveFacetsRefinements with SearchParameters.filters and SearchParameters.query
 * @param {object} searchParams - A SearchParameters Algolia object.
 * @returns {object} Formatted parameters for an Algolia query.
 */
export const buildParamsNoHits = (searchParams) => {
  const params = {
    query: searchParams.query,
    filters: searchParams.filters,
    hitsPerPage: 0,
  };

  const facetFilters = [];
  for (const attribute in searchParams.disjunctiveFacetsRefinements) {
    const values = searchParams.disjunctiveFacetsRefinements[attribute];
    if (values && values.length > 0) {
      const attributeOrFilters = values.map(value => `${attribute}:${value}`);
      facetFilters.push(attributeOrFilters);
    }
  }

  if (facetFilters.length > 0) {
    params.facetFilters = facetFilters;
  }

  return params;
};
